import { t } from "i18next"

type GetRoleDisplayNameType = (roleLabel: string) => string
export const getRoleDisplayName: GetRoleDisplayNameType = (roleLabel: string): string => {
  return roleLabel === "USER"
    ? t("roles.contributor", { ns: "settings" })
    : roleLabel === "OWNER"
      ? t("roles.admin", { ns: "settings" })
      : roleLabel?.slice(0, 1)?.toUpperCase() + roleLabel?.slice(1)?.toLowerCase()
}
